module.exports = __webpack_public_path__ + "assets/img/21_798_big.cd3c8869.jpg";